import React from 'react';
import Icon from '@mdi/react';
import { mdiCurrencyUsd, mdiCalendarToday, mdiCalendarMonth } from '@mdi/js';
import { formatCurrencyFromMinor } from '../../utils/currency';
import './EarningsSummary.css';

/**
 * EarningsSummary — Three stat cards: All Time, This Month, Last Month.
 */
function EarningsSummary({ summary }) {
  if (!summary) return null;

  const cards = [
    {
      label: 'All Time',
      icon: mdiCurrencyUsd,
      amount: summary.allTime?.amount,
      count: summary.allTime?.count,
      colorClass: 'summary-card--alltime',
    },
    {
      label: 'This Month',
      icon: mdiCalendarToday,
      amount: summary.thisMonth?.amount,
      count: summary.thisMonth?.count,
      colorClass: 'summary-card--thismonth',
    },
    {
      label: 'Last Month',
      icon: mdiCalendarMonth,
      amount: summary.lastMonth?.amount,
      count: summary.lastMonth?.count,
      colorClass: 'summary-card--lastmonth',
    },
  ];

  return (
    <div className="earnings-summary">
      {cards.map((card) => (
        <div key={card.label} className={`summary-card ${card.colorClass}`}>
          <div className="summary-card-header">
            <span className="summary-card-label">{card.label}</span>
            <div className="summary-card-icon">
              <Icon path={card.icon} size={0.9} />
            </div>
          </div>
          <div className="summary-card-amount">
            {formatCurrencyFromMinor(card.amount, summary.currency)}
          </div>
          <div className="summary-card-count">
            {card.count} transaction{card.count !== 1 ? 's' : ''}
          </div>
        </div>
      ))}
    </div>
  );
}

export default EarningsSummary;
